import { hotjarInit } from './lib/utils/hotjar';
import { Sentry } from '$lib/services/sentry';
import { getEnvironment } from '$lib/utils/environment';
import { ENVIRONMENTS } from '$lib/utils/constants';
import { getSentryConfig } from '$lib/services/sentry/config';
import { AppInitializationService } from '$lib/services/app-initialization';

const environment = getEnvironment();

Sentry.init({
	...getSentryConfig({
		environment,
		// @ts-ignore
		release: __RELEASE_NAME__ || 'local',
		// Prod stays at 0.25 (matches captured perf baselines); non-prod (review/dev/
		// staging/local) traces at 100% so custom spans are fully captured for validation.
		tracesSampleRate: environment === ENVIRONMENTS.PRODUCTION ? 0.25 : 1.0,
	}),
	integrations: [
		Sentry.thirdPartyErrorFilterIntegration({
			filterKeys: ['testing-key'],
			behaviour: 'apply-tag-if-contains-third-party-frames',
		}),
	],
	allowUrls: [/https?:\/\/(?:www\.|web\.dev\.)?abcmouse\.com/],
});

export const handleError = Sentry.handleErrorWithSentry();

hotjarInit();

/**
 * Hook for client init
 */
export async function init() {
	await AppInitializationService.initialize();
}
